import { Navigate, useLocation, useParams, type RouteObject } from "react-router-dom";
import { PEEK_PARAM, ROUTES } from "./routes";

type LegacyDestination = {
  path: string;
  destination: string | ((id: string) => string);
  peekParameter?: string;
};

const LEGACY_SHELL_DESTINATIONS: LegacyDestination[] = [
  { path: "/investments/investors", destination: ROUTES.INVESTMENTS.INVESTORS },
  { path: "/investments/main", destination: ROUTES.INVESTMENTS.MAIN, peekParameter: "investment" },
  {
    path: "/investments/contracts",
    destination: ROUTES.INVESTMENTS.CONTRACTS,
    peekParameter: "document_uuid",
  },
  { path: "/investments/calculator", destination: ROUTES.INVESTMENTS.CALCULATOR },
  { path: "/organization", destination: ROUTES.ORGANIZATION.GENERAL },
  { path: "/organization/general", destination: ROUTES.ORGANIZATION.GENERAL },
  { path: "/organization/users", destination: ROUTES.ORGANIZATION.USERS },
  { path: "/organization/templates", destination: ROUTES.ORGANIZATION.TEMPLATES },
  { path: "/organization/templates/:id", destination: ROUTES.ORGANIZATION.TEMPLATE_DETAIL },
];

function LegacyShellRedirect({ destination, peekParameter }: LegacyDestination) {
  const { id = "" } = useParams();
  const { search, hash } = useLocation();
  const query = new URLSearchParams(search);
  if (peekParameter && query.has(peekParameter)) {
    query.set(PEEK_PARAM, query.get(peekParameter) ?? "");
    query.delete(peekParameter);
  }
  const pathname = typeof destination === "string" ? destination : destination(id);
  return <Navigate replace to={{ pathname, search: query.toString(), hash }} />;
}

export const legacyShellRoutes: RouteObject[] = LEGACY_SHELL_DESTINATIONS.map((route) => ({
  path: route.path,
  element: <LegacyShellRedirect {...route} />,
}));
